// Injected at build time from package.json (see the start/build scripts).
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0-dev';

export const LAST_ACKNOWLEDGED_VERSION_KEY = 'last_acknowledged_version';

const VERSION_CORE = /^v?(\d+)\.(\d+)\.(\d+)/i;

export function parseVersion(version) {
  const match = VERSION_CORE.exec(String(version ?? '').trim());
  return match ? match.slice(1, 4).map(Number) : null;
}

/**
 * Compare two versions on their semver core (major.minor.patch). Prerelease
 * and build metadata are ignored. Unparseable versions sort below valid ones.
 * Returns -1, 0, or 1.
 */
export function compareVersions(a, b) {
  const left = parseVersion(a);
  const right = parseVersion(b);
  if (!left || !right) {
    if (left) return 1;
    if (right) return -1;
    return 0;
  }
  for (let i = 0; i < 3; i += 1) {
    if (left[i] !== right[i]) return left[i] > right[i] ? 1 : -1;
  }
  return 0;
}

export function isNewer(candidate, baseline) {
  return compareVersions(candidate, baseline) > 0;
}
